import { jsx } from 'react/jsx-runtime';
import { twMerge } from 'tailwind-merge';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const VARIANTS = [
    {
        name: 'title1',
        class: 'typo-title1'
    },
    {
        name: 'title2',
        class: 'typo-title2'
    },
    {
        name: 'title3',
        class: 'typo-title3'
    },
    {
        name: 'subTitle1',
        class: 'typo-subTitle1'
    },
    {
        name: 'subTitle2',
        class: 'typo-subTitle2'
    },
    {
        name: 'contents1',
        class: 'typo-contents1'
    },
    {
        name: 'contents2',
        class: 'typo-contents2'
    },
    {
        name: 'body1',
        class: 'typo-body1'
    },
    {
        name: 'body2',
        class: 'typo-body2'
    },
    {
        name: 'body3',
        class: 'typo-body3'
    },
    {
        name: 'caption1',
        class: 'typo-caption1'
    },
    {
        name: 'caption2',
        class: 'typo-caption2'
    }
];
/**
 * Typography
 * @param {Object} props
 * @param {React.ReactNode} props.children - Typography 내부에 들어갈 컨텐츠
 * @param {string} props.variant - 텍스트 스타일 variant ('title1' | 'title2' | 'title3' | 'subTitle1' | 'subTitle2' | 'contents1' | 'contents2' | 'body1' | 'body2' | 'body3' | 'caption1' | 'caption2')
 * @param {string} [props.className] - 추가적인 CSS 클래스
 * @param {keyof JSX.IntrinsicElements} [props.as='span'] - 렌더링할 HTML 요소
 */ const Typography = (_param)=>{
    var { children, variant, className, as = 'span' } = _param, rest = _object_without_properties(_param, [
        "children",
        "variant",
        "className",
        "as"
    ]);
    var _VARIANTS_find;
    const Component = as || 'span';
    const matchedVariantClass = ((_VARIANTS_find = VARIANTS.find((eachVariant)=>eachVariant.name === variant)) === null || _VARIANTS_find === void 0 ? void 0 : _VARIANTS_find.class) || '';
    return /*#__PURE__*/ jsx(Component, _object_spread_props(_object_spread({
        className: twMerge('tracking-default', matchedVariantClass, className)
    }, rest), {
        children: children
    }));
};

export { Typography as default };
